import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://admin-api.betterfield.pt';

// Create axios instance with auth token
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to all requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

// Tenants Service
export const tenantsService = {
  async getAll(env = 'test') {
    const response = await api.get(`/api/tenants?env=${env}`);
    return response.data;
  },

  async getById(id, env = 'test') {
    const response = await api.get(`/api/tenants/${id}?env=${env}`);
    return response.data;
  },

  async create(tenantData, env = 'test') {
    const response = await api.post(`/api/tenants?env=${env}`, tenantData);
    return response.data;
  },

  async update(id, tenantData, env = 'test') {
    const response = await api.put(`/api/tenants/${id}?env=${env}`, tenantData);
    return response.data;
  },

  async delete(id, env = 'test') {
    const response = await api.delete(`/api/tenants/${id}?env=${env}`);
    return response.data;
  },

  async deploy(tenantId, environment, env = 'test') {
    const response = await api.post(`/api/tenants/${tenantId}/deploy?env=${env}`, {
      environment,
    });
    return response.data;
  },
};

export default api;
